import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { Dictionary } from '@/types';
import { FILTER_NAV, FILTER_TITLE, ACTIVITIES_ROUTE } from './const';
import {
  ActivityLevels,
  ActivityMembers,
  Children,
  Municipalities,
  Sections,
} from './types';

@Component
export default class PageActivitiesFilter extends Vue {
  // Vuex
  @State municipalities: Municipalities;
  @State('activityLevels') levels: ActivityLevels;
  @State('activityMembers') members: ActivityMembers;
  @State('activitySections') sections: Sections;

  // Readonly
  readonly filterNav = FILTER_NAV;
  readonly filterTitle = FILTER_TITLE;

  // Computed
  get filterProps() {
    const {
      filterNav,
      filterTitle,
      localFilterFields,
      localFilterValues,
      routeName,
    } = this;
    return {
      title: filterTitle,
      route: routeName,
      key: JSON.stringify(localFilterValues),
      fields: localFilterFields,
      values: localFilterValues,
      nav: filterNav,
      codeSection: 'section',
      codeSubsection: 'subsection',
    };
  }

  get filterFields() {
    const { levels, members, municipalities, sections } = this;
    // Каталог мероприятий
    const result = [
      {
        title: 'Место проведения',
        placeholder: 'Место проведения',
        code: 'municipality',
        data: [
          {
            name: 'Любой муниципалитет',
            id: '',
          },
          ...municipalities,
        ],
        filterable: 'auto',
      },
      {
        title: 'Организатор',
        code: 'organizator',
        data: [
          { name: 'Любой организатор', id: '', default: true },
          ...this.$store.state.organizatorsFullList,
        ],
      },
      {
        title: 'Участники',
        code: 'members',
        multiple: true,
        data: [
          { name: 'Любой участник', id: '', default: true },
          ...this.$store.state.activityMembers,
        ],
      },

      /*
      {
        title: 'Участник',
        placeholder: 'Участник',
        code: 'member',
        data: [
          {
            name: 'Любой участник',
            id: '',
          },
          ...members,
        ],
      },

      {
        title: 'Уровень',
        placeholder: 'Уровень',
        code: 'level',
        data: [
          {
            name: 'Любой уровень',
            id: '',
          },
          ...levels,
        ],
      },
      */

      // {
      //   title: 'Раздел',
      //   code: 'section',
      //   data: [
      //     {
      //       name: 'Любой раздел',
      //       id: '',
      //     },
      //     ...sections.map(({ name, code, children }) => ({
      //       name,
      //       id: code,
      //       children: !children
      //         ? []
      //         : children.map((item) => ({
      //             id: item.code,
      //             name: item.name,
      //           })),
      //     })),
      //   ],
      //   filterable: 'auto',
      // },

      // {
      //   title: 'Подраздел',
      //   code: 'subsection',
      //   data: [
      //     {
      //       name: 'Любое подраздел',
      //       id: '',
      //       default: true,
      //     },
      //     ...sections.reduce((result: Children, section): Children => {
      //       const { children, code } = section;
      //       if (!children || !Array.isArray(children)) return result;
      //       return [
      //         ...result,
      //         ...children.map((item) => ({
      //           id: item.code,
      //           name: item.name,
      //           parent: code,
      //         })),
      //       ];
      //     }, [] as Children),
      //   ],
      //   filter: (list: Children, current: any) => {
      //     const result = list.filter(
      //       (item) => item.default || item.parent === current.section,
      //     );
      //     return result;
      //   },
      //   filterable: 'auto',
      // },
    ];

    return result;
  }

  get filterValues(): Dictionary<any> {
    return {
      ...this.$route.params,
      ...this.$route.query,
    };
  }

  get localFilterValues() {
    return this.filterValues;
  }

  get localFilterFields() {
    const hidden = {
      type: 'hidden',
      code: 'limit',
    };
    return [...this.filterFields, hidden];
  }

  get routeName() {
    return ACTIVITIES_ROUTE;
  }
}



// WEBPACK FOOTER //
// ./src/pages/activities/filter.ts